import { Collapsible, CollapsibleProps } from "components/Collapsible";
import { ReactStoryblokComponent } from "types/storyblok";

const CollapsibleAdapter = ({
  blok: { variant, isChat, collapsibleItems, heading },
}: ReactStoryblokComponent<CollapsibleProps>) => (
  <Collapsible heading={heading} variant={variant} isChat={isChat} collapsibleItems={collapsibleItems} />
);

export default CollapsibleAdapter;
